import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { ApiVisa } from '../../../shared';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../../shared/api-response.model';

@Injectable({
    providedIn: 'root'
  })
  export class LogisticHubHdrService extends BaseApiTemplateService<any> {
      
    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/logistic-hubs/backoffice-ep';
  
    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/logistic-hubs/backoffice-ep';
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/logistic-hubs/backoffice-ep';
      this.httpClient = http;
    }

    public getByCriteriaPost(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url + this.endpoint_path + '/query';
        }
        return this.httpClient.post<ApiResponseModel<any>>(
          url,
          dtoObject,
          this.getHttpHeader(visa)
        );
      }

}